import {
  ADD_ACTIVE_EXPENSE_TAG_BUCKETS,
  ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS,
  ExpenseBucketsAction
} from '@Actions/expenseBucketsActions';

import { IExpenseTagBucketModel } from '@Shared/models';

interface IExpenseTagBucketState {
  activeExpenseBuckets: IExpenseTagBucketModel[];
  activeTeamFieldBucketsWithActiveTags: IExpenseTagBucketModel[];
}

export const defaultState: IExpenseTagBucketState = {
  activeExpenseBuckets: [],
  activeTeamFieldBucketsWithActiveTags: []
};

export function expenseBucketsReducer(state = defaultState, action: ExpenseBucketsAction): IExpenseTagBucketState {
  switch (action.type) {
    case ADD_ACTIVE_EXPENSE_TAG_BUCKETS: {
      return {
        ...state,
        activeExpenseBuckets: action.payload
      };
    }
    case ADD_ACTIVE_TEAM_FIELD_BUCKETS_WITH_ACTIVE_TAGS: {
      return {
        ...state,
        activeTeamFieldBucketsWithActiveTags: action.payload
      };
    }
    default:
      return state;
  }
}
